import React from 'react'

const Spinner = () => {
  return (
    <div className='w-[100%] flex justify-center items-center h-[50vh]'>
    <div className=' custom-loader'></div>
    </div>
  )
}

export default Spinner